/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import useUserSessionOutletContext from 'hooks/useUserSessionIOutletContext';
import { resolveSclaApplication } from 'utils/sclaApplicationKind';
import SclaApplicationBackground from './SclaApplicationBackground';
import SclaApplicationFamily from './SclaApplicationFamily';
import SclaApplicationPrompts from './SclaApplicationPrompts';
import SclaApplicationSchool from './SclaApplicationSchool';
import SclaApplicationSignatures from './SclaApplicationSignatures';
import SclaApplicationTranscripts from './SclaApplicationTranscripts';
import SclaAppLayout from './SclaAppLayout';
import SclaApplicationLetterOfRec from './SclaApplicationLetterOfRec';
import SclaHome from './SclaHome';
import CompleteApplicantInfo from '../components/CompleteApplicantInfo';
import { needsApplicantInfo } from '../utils/applicantProfileGate';

export function SclaApplicationRoutes() {
  const { user } = useUserSessionOutletContext();

  if (!resolveSclaApplication(user.type).allowed) {
    return <Navigate to="/home" replace />;
  }

  if (needsApplicantInfo(user)) {
    return <CompleteApplicantInfo user={user} />;
  }

  return (
    <Routes>
      <Route index element={<Navigate to="home" replace />} />
      <Route path="home" element={<SclaHome user={user} />} />
      <Route element={<SclaAppLayout user={user} />}>
        <Route path="background" element={<SclaApplicationBackground />} />
        <Route path="family" element={<SclaApplicationFamily />} />
        <Route path="school" element={<SclaApplicationSchool />} />
        <Route path="prompts" element={<SclaApplicationPrompts />} />
        <Route
          path="transcripts"
          element={<SclaApplicationTranscripts />}
        />
        <Route path="rec" element={<SclaApplicationLetterOfRec />} />
        <Route path="signature" element={<SclaApplicationSignatures />} />
      </Route>
      <Route path="*" element={<Navigate to="/scla-application/home" replace />} />
    </Routes>
  );
}
